"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CropArea = exports.ImagePinComponentSchema = void 0;
const zod_1 = require("zod");
const base_pin_component_1 = require("./base-pin-component");
const shadow_setting_1 = require("../setting/shadow-setting");
const transparency_setting_1 = require("../setting/transparency-setting");
/**
 * The portion of the full image that is visible within the bounds of the image
 * pin component.
 */
const CropAreaSchema = zod_1.z.object({
    /**
     * The focus point of the crop area inside the full image, represented as
     * fractions between 0 and 1. Functions similarly to using percentages for the
     * `background-position` property in CSS.
     *
     * A value of (0, 0) means the focus is in the top-left corner, causing the
     * top-left corners of the image pin component and the full image to align,
     * while a value of (1, 1) means the bottom-right corners align.
     *
     * The default value is `(0.5, 0.5)`, which centers the full image in the
     * image pin component.
     */
    focus: base_pin_component_1.VectorSchema,
    /**
     * The scale factor determines how much larger the full image is compared to
     * the image pin component, applied along the most constrained dimension
     * (either width or height).
     *
     * Note that there is currently no way to create distorted images (where the
     * aspect ratio no longer matches that of the original image), so we only need
     * a single scale value that is used for both dimensions.
     *
     * The default value is `1`, meaning the full image fits around the image pin
     * component with no room to spare. This behavior, combined with a focus of
     * `(0.5, 0.5)`, mimics the behavior of `background-size: cover`.
     */
    scale: zod_1.z.number(),
});
const ImagePinComponentSettingsSchema = base_pin_component_1.BasePinComponentSettingsSchema.merge(zod_1.z.object({
    url: zod_1.z.string(), // TODO: Can be empty in PoC, fix later .min(1),
    borderSize: zod_1.z.number().optional(),
    borderColor: zod_1.z.string().optional(),
    borderRadius: zod_1.z.number().optional(),
    shadow: shadow_setting_1.ShadowSettingKeySchema,
    transparency: transparency_setting_1.TransparencySettingSchema,
    cropArea: CropAreaSchema.optional(),
    zoomableInInteractiveViewer: zod_1.z.boolean().optional(),
}));
exports.ImagePinComponentSchema = base_pin_component_1.BasePinComponentSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('IMAGE'),
    settings: ImagePinComponentSettingsSchema,
}));
exports.CropArea = {
    cover: { focus: { x: 0.5, y: 0.5 }, scale: 1 },
};
//# sourceMappingURL=image-pin-component.js.map